import "./App.css";

import DictionarySearch from "./DictionarySearch";

function App() {
  return (
    <div className="App">
      <div className="container">
        <h1 className="app-title mt-4">Dictionary Search Engine</h1>
        <DictionarySearch />
      </div>
    </div>
  );
}

export default App;
